import React from 'react';
import { HtmlString, Switcher, withLoading } from '@adjust/dashboard-components';

export interface TwoFactorConfigurationContentProps {
  closeSidebar: () => void;
  onToggle: (enabled: boolean) => void;
  enabled: boolean;
}

const TwoFactorConfigurationContentBase: React.FC<TwoFactorConfigurationContentProps> = ({
  closeSidebar,
  onToggle,
  enabled,
}) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(event.target.checked);
  };

  return (
    <>
      <div className="content-title-box without-background flex-auto">
        <h3 className="content-heading">{t('security-package.2fa.sidebar.title')}</h3>
        <p className="info small">
          <HtmlString>{t('security-package.2fa.sidebar.description')}</HtmlString>
        </p>
      </div>
      <div className="sidebar-view flex-one flex-box-column">
        <div className="flex-one flex-box-column without-background content-inner">
          <div className="flex-one panel-content form-row">
            <Switcher
              value={enabled}
              name="enabled"
              label={t('security-package.2fa.switcher.label')}
              onChange={onChange}
            />
          </div>
          <div className="flex-auto panel-footer">
            <div className="flex-box-row">
              <button type="button" className="btn flex-one" onClick={closeSidebar}>
                {t('action.cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const TwoFactorConfigurationContent = withLoading(TwoFactorConfigurationContentBase);
